const { onlyAlphaNumeric } = require('../helpers');

exports.zipCodeNormalize = (zipCode) => {
  if (!zipCode) {
    return zipCode;
  }
  const zip = onlyAlphaNumeric(zipCode);
  if (zipCode.length <= 3) {
    return zip;
  }
  return `${zip.slice(0, 3).toUpperCase()}${zip.slice(3, 9)}`;
};

exports.countryDefinition = {
  country: 'Serbia',
  code: 'RS',
  schema: {
    company: { label: 'Company' },
    address: { label: 'Address' },
    address2: { label: 'Address 2' },
    city: { label: 'Town' },
    stateCode: { label: 'Post Office' },
    zipCode: { label: 'Postcode', normalize: exports.zipCodeNormalize }
  },
  viewFormat: [
    ['company'],
    ['address'],
    ['address2'],
    ['city'],
    ['stateCode'],
    ['zipCode']
  ],
  formFormat: [
    ['company'],
    ['address'],
    ['address2'],
    ['city'],
    ['stateCode'],
    ['zipCode']
  ],
  requiredFormFields: [
    { field: 'address' },
    { field: 'city' },
    { field: 'stateCode' },
    {
      field: 'zipCode',
      validationRegex: new RegExp(/^PAK[0-9]{6}$/),
      error: 'Must be PAK + 5 numbers, PAK456769'
    }
  ]
};
